__turbopack_context__.v({
  "buttonStack": "Dialog-module__DG5ioW__buttonStack",
  "dialogContent": "Dialog-module__DG5ioW__dialogContent",
  "frameLogoContainer": "Dialog-module__DG5ioW__frameLogoContainer",
});
